export default {
  data() {
    const advisingBankSchema = [
      {
        label: 'Bank Name',
        type: 'input',
        key: 'bankName',
      },
      {
        label: 'Reference Number',
        type: 'input',
        key: 'referenceNumber',
      },
    ]
    return {
      advisingBankSchema,
    }
  },
}
